module.exports = __webpack_public_path__ + "static/media/Roboto-Medium.50d01d3e.woff2";